import { unbox, Boxed } from 'ngrx-forms';

/**
 * Util to use with ngrx-form objects
 * R: object or object property
 */
export function objectUnbox<T, U = T>(obj: T | Boxed<T | null> | null, prop?: string) {
  const unboxedObj = unbox(obj);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  if (unboxedObj && prop && unboxedObj.hasOwnProperty(prop)) {
    return (unboxedObj as any)[prop] as U;
  }

  return unboxedObj;
}
